import React from "react";
import sup from "../Assests/supIMg.png";
// import arrR from "../Assests/alratv_img/arrow-right.png";
import arrR from "../Assests/right-arrow.svg";
const Support = () => {
  return (
    <div className="w-full grid grid-cols-1 xl:grid-cols-12">
      {/* LEFT SIDE */}
      <div className="bg-[#EFE1C280] col-span-12 xl:col-span-6 px-6 sm:px-8 md:px-12 xl:px-16 2xl:px-24 py-10">
        <div className="h-full flex flex-col justify-between max-w-[1140px] mx-auto">
          <div className="text-center">
            <h2
              className="text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[66px] font-bold text-[#222222] mb-6 lg:mb-[32px]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Why We Need Your Support
            </h2>
            <p
              className="text-base md:text-lg lg:text-[21px] font-normal leading-relaxed lg:leading-[28px] text-[#333] mb-6 lg:mb-[32px]  mx-auto"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Our current space has served us well — but we have outgrown it. To
              fulfil our growing mission, we need your help.
            </p>
            <p
              className="text-[#222222] text-center text-base md:text-lg lg:text-[21px] font-bold leading-normal lg:leading-[32px] mb-2 lg:mb-4"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Your Donation Will Help Us:
            </p>
            <div className="self-center w-auto mt-4 text-left mx-auto">
              <ul
                className="xl:max-w-[680px] list-disc pl-6 space-y-2 md:space-y-3 text-base md:text-lg lg:text-[21px] text-[#222222]"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                <li>Build a larger, purpose-built studio</li>
                <li>
                  Invest in modern equipment for high-quality global broadcasts
                </li>
                <li>
                  Support our team of spiritual educators, hosts, and creators
                </li>
                <li>Expand our reach to more countries and communities</li>
              </ul>
            </div>
          </div>

          <a
            href="https://buy.stripe.com/5kA17AcGfgIRaCAdQR"
            target="_blank"
            rel="noreferrer"
            className="hover:cursor-pointer w-full sm:w-[300px] md:w-[350px] lg:w-[400px] h-12 md:h-[56px] mt-10 text-white text-base lg:text-[21px] font-bold rounded-[24px] self-center flex items-center justify-center gap-2 bg-gradient-to-r from-[#8C0000] to-[#FF0000]"
          >
            DONATE NOW{" "}
            <span className="text-2xl lg:text-[30px]">
              <img alt="arrow" src={arrR} className="w-[24px]" />
            </span>
          </a>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="bg-gradient-to-b from-[#8C0000] to-[#FF0000] text-white col-span-12 xl:col-span-6 px-6 sm:px-8 md:px-12 xl:px-16 2xl:px-24 py-10">
        <div className="flex flex-col justify-between max-w-[1140px] mx-auto">
          <div className="flex items-center gap-4 justify-center mb-6">
            <img
              src={sup}
              alt="Logo"
              className="w-[180px] md:w-[220px] lg:w-[255px] h-auto object-contain"
            />
          </div>

          <div className="text-center">
            <p
              className="text-xl md:text-2xl lg:text-[32px] text-[#FFDF9C] font-normal leading-normal lg:leading-[64px] mb-2 lg:mb-[12px]"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Join Us:
            </p>
            <h2
              className="text-white text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[64px] font-bold inline-block px-4 lg:px-6 rounded mb-4 lg:mb-[24px]  mx-auto"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Be Part of the Future
            </h2>
            <p
              className="text-xl md:text-2xl lg:text-[30px] leading-tight lg:leading-[32px] font-normal mb-4 lg:mb-[24px] px-2 lg:px-4  mx-auto"
              style={{ fontFamily: "Manrope, sans-serif" }}
            >
              Help us bring more light into the world — one broadcast at a time.
            </p>
            <div className="xl:max-w-[860px] text-center  mx-auto px-2 lg:px-4">
              <p
                className="text-base md:text-lg lg:text-[21px] leading-normal lg:leading-[32px] font-normal"
                style={{ fontFamily: "Manrope, sans-serif" }}
              >
                Whether you've been with us since the beginning or just found us
                yesterday, you are part of the ALRA TV family. This next chapter
                cannot happen without you. We have set up{" "}
                <span className="font-bold">‘MFI - The Awakening Network’</span>{" "}
                so you can support the cause that matters most.
              </p>
            </div>
          </div>

          <a
            href="https://buy.stripe.com/5kA17AcGfgIRaCAdQR"
            target="_blank"
            rel="noreferrer"
            className="hover:cursor-pointer w-full sm:w-[300px] md:w-[350px] lg:w-[400px] h-12 md:h-[56px] mt-10 font-bold flex items-center justify-center border border-white border-4 md:border-[4px] text-white self-center text-base lg:text-[21px] rounded-[24px] hover:bg-white hover:text-[#111] transition"
          >
            DONATE NOW{" "}
            <span className="ml-2 text-xl lg:text-[20px]">
              <img alt="arrow" src={arrR} className="w-[24px]" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Support;
